export const BASIC_AUTH_PROTECTED_PATHS: ReadonlyArray<string> = Object.freeze([
  '/v1/auth/users/login',
  '/v1/auth/users/refresh',
  '/v1/auth/users/oauth/google',
  '/v1/auth/users/register',
  '/v1/auth/users/verify-email-otp',
  '/v1/auth/users/resend-email-otp',
  '/v1/auth/stores/login',
  '/v1/auth/stores/oauth/google',
  '/v1/auth/stores/register',
  '/v1/auth/malls',
  '/v1/auth/pincodes',
  '/v1/geocode',
  '/v1/profile/users/browser/launch',
  '/v1/profile/stores/generate-store-code',
  '/v1/queue/join',
  '/v1/auth/stores/forgot-password/request-otp',
  '/v1/auth/stores/forgot-password/verify-otp',
  '/v1/auth/stores/forgot-password/reset',
  '/v1/auth/oauth/google',
  '/v1/auth/stores/refresh',
  '/v1/mobile/stores',
  '/actuator',
  '/error'
]);
